import React from 'react'
import ErrorImg from '@assets/images/error_500.png'
import g from '@components/GoEasy'
import { Spin } from 'antd'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      height: 600,
      loading: false
    }
    this.wrapper = React.createRef()
  }

  componentDidMount() {}

  componentDidCatch(error, errorInfo) {
    if (error.name === 'ChunkLoadError') {
      window.location.reload()
      this.setState({
        loading: true
      })
      return
    }
    g.socket.publish({
      channel: 'logger',
      message: JSON.stringify({
        error: {
          name: error.name,
          message: error.message
        },
        errorInfo,
        time: new Date().toLocaleString()
      })
    })
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          ref={this.wrapper}
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: this.state.height,
            alignItems: 'center',
            width: '60%',
            margin: '0 auto'
          }}
        >
          <div style={{ flex: 2 }}>
            <img src={ErrorImg} alt="" style={{ width: '100%' }} />
          </div>
          <div style={{ marginLeft: 120, minWidth: 200, flex: 1 }}>
            <h1
              style={{
                fontSize: 96,
                color: '#545455',
                marginBottom: 24,
                lineHeight: 1
              }}
            >
              500
            </h1>
            <p style={{ fontSize: 24, color: '#898A8C' }}>抱歉服务器出错了</p>
          </div>
        </div>
      )
    }
    if (this.state.loading) {
      return (
        <div
          ref={this.wrapper}
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: this.state.height,
            alignItems: 'center',
            width: '60%',
            margin: '0 auto'
          }}
        >
          <Spin />
        </div>
      )
    }
    return this.props.children
  }
}
